<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Icon" />
    </div>
    <span class="title">Gerar Comprovativo de Subsídio</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (click)="onCancel()"></p-button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <label for="numeroMemorando">Número do Memorando</label>
        <input id="numeroMemorando" type="number" class="w-full" pInputText formControlName="numeroMemorando" />
      </div>
      <div class="field col-6">
        <label for="numeroEstudantes">Número de Estudantes</label>
        <input id="numeroEstudantes" type="number" class="w-full" pInputText formControlName="numeroEstudantes" />
      </div>
      <div class="field col-6">
        <label for="valorSubsidio">Valor do Subsídio</label>
        <input id="valorSubsidio" type="number" class="w-full" pInputText formControlName="valorSubsidio" />
      </div>
      <div class="field col-6">
        <label for="de">De</label>
        <p-calendar id="de" formControlName="de" class="w-full" view="month" dateFormat="mm/yy"
          [showIcon]="true"></p-calendar>
      </div>
      <div class="field col-6">
        <label for="ate">Até</label>
        <p-calendar id="ate" formControlName="ate" class="w-full" view="month" dateFormat="mm/yy"
          [showIcon]="true"></p-calendar>
      </div>
      <div class="field col-12">
        <label for="dataEmissao">Data de Emissão</label>
        <input id="dataEmissao" type="datetime-local" class="w-full" pInputText formControlName="dataEmissao" />
      </div>
    </div>
    <div class="modal-footer">
      <p-button class="p-button-outlined" label="Cancelar" (click)="onCancel()"></p-button>
      <button pButton type="submit" label="Exportar" class="p-button-primary" [disabled]="!form.valid"></button>
    </div>
  </form>
</div>
